export const MAIN_PAGE = 'Main Page';
export const SEARCH = 'Search';
export const SEARCH_ITEM = 'Content Item';
export const VIDEO_QC_PLAYER = 'Video QC Player';
export const QC_WORK_QUEUE = 'QC Work Queue';
export const QC_TOOLS = 'QC Tools';
export const MANAGE_INGEST = 'Manage Ingests';
export const INGEST_DATA = 'Ingest Data';
export const DELIVERY_MANAGER_MANIFEST = 'Delivery manifest';
export const INGEST_SESSION_ERROR = 'Ingest Session Error';
export const INGEST_REPORT = 'Ingest Report';
export const MEDIA_ORDER_LIST = 'Media Orders';
export const MEDIA_ORDER_ITEM = 'Media Order Item';
export const QC_MANAGER = 'QC Manager';
export const DELIVERY_MANAGER = 'Delivery Manager';
export const INGEST_CONFIG = 'Ingest Configs';
export const EDIT_INGEST_CONFIG = 'Edit Ingest Config';
export const CREATE_NEW_INGEST = 'Create New Ingest';
export const CONTENT_PARTNERS = 'Content Partners';
export const EDIT_CONTENT_PARTNER = 'Edit Content Partner';
export const CREATE_CONTENT_PARTNER = 'Create Content Partner';
export const USERS_LIST = 'Users List';
export const ADD_USERS = 'Add User';
export const USER_DETAILS = 'User Details';
export const NOT_FOUND = '404 page';
